import enviro from 'enviro';
const TrialIds = {
  SALES_ENTERPRISE: 1,
  MARKETING_ENTERPRISE: 2,
  SERVICE_ENTERPRISE: 3,
  MARKETING_PRO: 4,
  CMS_PROFESSIONAL: 7,
  SALES_PROFESSIONAL: 8,
  SERVICE_PROFESSIONAL: 9,
  CMS_ENTERPRISE: enviro.isProd() ? 18 : 17,
  OPERATIONS_PROFESSIONAL: enviro.isProd() ? 35096 : 43098,
  OPERATIONS_ENTERPRISE: enviro.isProd() ? 52399 : 70192,
  MARKETING_PLUS_PROFESSIONAL_BUNDLE: enviro.isProd() ? 200098 : 270355,
  MARKETING_PLUS_ENTERPRISE_BUNDLE: enviro.isProd() ? 200097 : 270725
};
export const apiNameToTrialIds = {
  'sales-hub-enterprise': TrialIds.SALES_ENTERPRISE,
  'marketing-hub-enterprise': TrialIds.MARKETING_ENTERPRISE,
  'service-hub-enterprise': TrialIds.SERVICE_ENTERPRISE,
  'marketing-hub-professional': TrialIds.MARKETING_PRO,
  'cms-hub-professional': TrialIds.CMS_PROFESSIONAL,
  'sales-hub-professional': TrialIds.SALES_PROFESSIONAL,
  'service-hub-professional': TrialIds.SERVICE_PROFESSIONAL,
  'cms-hub-enterprise': TrialIds.CMS_ENTERPRISE,
  'operations-hub-professional': TrialIds.OPERATIONS_PROFESSIONAL,
  'operations-hub-enterprise': TrialIds.OPERATIONS_ENTERPRISE,
  'marketing-plus-professional-bundle': TrialIds.MARKETING_PLUS_PROFESSIONAL_BUNDLE,
  'marketing-plus-enterprise-bundle': TrialIds.MARKETING_PLUS_ENTERPRISE_BUNDLE
};